import { useForm, useFormState } from "react-hook-form";

import Validations from "@helpers/validations";
import { object } from "yup";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const DEFAULT_VALUES = {
    title  : "",
    content: ""
};
const useUpsert = (props) => {
    const {
        modalConfig: { row },
        handleModal,
        getAllTemplates
    } = props;
    const { platformId } = useParams();
    
    const { loading, axiosInstance } = useAxios({ base: "panel" });

    const { requiredValidation } = Validations();

    const methods = useForm({
        defaultValues: DEFAULT_VALUES,

        resolver: yupResolver(
            object().shape({
                title  : requiredValidation({ name: "Title" }),
                content: requiredValidation({ name: "Content" })
            })
        )
    });

    const { control, handleSubmit, reset } = methods;
    const { isDirty } = useFormState({ control });

    useEffect(() => {
        if (size(row)) {
            reset({
                title  : row.title,
                content: row.content
            });
        } else {
            reset(DEFAULT_VALUES);
        }
    }, [row]);

    const onSubmit = handleSubmit(async (data) => {
        const payload = {
            title  : data.title,
            content: data.content
        };

        if (row._id) {
            await axiosInstance.patch(`/notes/${platformId}/template/${row._id}`, payload);
        } else {
            await axiosInstance.post(`/notes/${platformId}/template`, payload);
        }

        handleModal();
        getAllTemplates();
    });

    return {
        onSubmit,
        methods,
        updateLoading: loading,
        isDirty
    };
};

export default useUpsert;
